import { translate } from '@cashfree-intl/coherent';
import * as Yup from 'yup';

const message = {
  required: `${translate('this_is_a_required_field')}`,
};

export const userDetailsValidate = values => {
  const errors = {};
  const isValidPassword = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+.=])(?=\S+$).{8,20}$/.test(
    values.password,
  );
  if (values.password.trim() === '') errors.password = message.required;
  else if (!isValidPassword)
    errors.password = `${translate('enter_valid_password')}`;
  return errors;
};

export const merchantDetailsValidate = values => {
  const errors = {};
  // eslint-disable-next-line
  const isUrl = /(?:(?:https?):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?$/.test(
    values.merchantSiteUrl,
  );

  if (
    values.countryCode &&
    values.phone &&
    values.countryCode === '+91' &&
    !/^[6-9]\d{9}$/.test(values.phone) // test valid 10 digit indian phone numbers
  )
    errors.phone = `${translate('enter_valid_contact_number')}`;

  return errors;
};

export const userDetailsSchema = Yup.object({
  email: Yup.string()
    .email(`${translate('incorrect_email_address')}`)
    .required(message.required),
  refCode: Yup.string(),
});

export const merchantDetailsSchema = Yup.object({
  phone: Yup.string()
    .matches(/^[0-9]{10,13}$/, `${translate('enter_valid_contact_number')}`)
    .required(message.required),
});

export const importMerchantDetailsSchema = Yup.object({
  phone: Yup.string()
    .required(message.required)
    .matches(/^[0-9]{1,20}$/, `${translate('enter_valid_contact_number')}`),
});
